import { Button, Draggable, FileUploader, Form } from 'devextreme-react'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import erorSound from '../../../assets/audio/alert-error.wav'
import api from '../../../services/api-configuration'
import useFormatMessage from '../../../utils/useFormatMessage'

const HasarBildirimiAddModal = ({
    isOpen,
    setIsOpen,
    area
}) => {
    const { t } = useFormatMessage()
    const [sase, setSase] = useState("")
    const formRef = useRef(null)
    const notifySuccess = (message) => toast.success(`${message}`)
    const notifyWarning = (message) => toast.warning(`${message}`)

    const [formData, setFormData] = useState({
        damage_date: new Date(),
        chassis_no: '',
        damage_region: area,
        reporter_name: localStorage.getItem("fullName"),
        responsible: '',
        description: '',
        image: null
    });

    const formItems = {
        items: [{
            itemType: 'group',
            colCount: 1,
            items: [
                //     {
                //     dataField: 'damage_date',
                //     editorType: 'dxDateBox',
                //     label: {
                //         location: 'top',
                //         text: t('Hasar Tarihi')
                //     },
                //     editorOptions: {
                //         type: 'datetime',
                //         displayFormat: 'dd/MM/yyyy HH:mm',
                //         disabled: true,
                //         width: '100%'
                //     }
                // },
                {
                    dataField: 'chassis_no',
                    label: {
                        location: 'left',
                        text: t('Şase')
                    },
                    editorOptions: {
                        disabled: true,
                        value: sase,
                        width: '100%'
                    }
                },
                // {
                //     dataField: 'damage_region',
                //     label: {
                //         location: 'top',
                //         text: t('Hasar Bildirilen Bölge')
                //     },
                //     editorOptions: {
                //         disabled: true,
                //         width: '100%'
                //     }
                // },
                // {
                //     dataField: 'reporter_name',
                //     label: {
                //         location: 'top',
                //         text: t('Bildiren Kişi')
                //     },
                //     editorOptions: {
                //         disabled: true,
                //         width: '100%'
                //     }
                // },
                {
                    dataField: 'responsible',
                    label: {
                        location: 'top',
                        text: t('Hasar Sorumlusu')
                    },
                    editorType: 'dxTextBox',  // Changed from dxSelectBox to dxTextBox
                    editorOptions: {
                        width: '100%'
                    }
                }, {
                    dataField: 'description',
                    editorType: 'dxTextArea',
                    label: {
                        location: 'top',
                        text: t('Hasar Açıklama')
                    },
                    editorOptions: {
                        height: 100,
                        width: '100%'
                    },
                    validationRules: [{
                        type: 'required',
                        message: t('Açıklama zorunludur')
                    }]
                }]
        }]
    };

    const createDamegeReport = async () => {
        const result = formRef.current.instance.validate();

        if (!result.isValid) {
            notifyWarning(t("Lütfen zorunlu alanları doldurunuz"));
            return;
        }

        // if (!formData.image) {
        //     notifyWarning(t("Lütfen hasar görseli yükleyiniz"));
        //     return;
        // }

        const body = {
            damage_date: moment(formData.damage_date).format('YYYY-MM-DD HH:mm'),
            chassis_no: sase,
            damage_region: area,
            reporter_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            responsible: formData.responsible,
            description: formData.description
        };

        const formDataToSend = new FormData();
        formDataToSend.append("data", JSON.stringify(body));
        formDataToSend.append("image", formData.image);

        try {
            await api.post('/damage/add', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            notifySuccess(t("Hasar bildirimi başarılı"));
            setIsOpen(false);
        }
        catch (error) {
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
            const errorSound = document.getElementById("errorSound");
            errorSound.play();

            Swal.fire({
                icon: 'error',
                title: t('Hata'),
                text: t(error.response.data.error),
            });

            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Hasar bildirimi yapılamadı') + ":" + errorMessage);
            console.error("Hasar bildirimi yapılamadı");
        }
    };

    const handleFieldDataChanged = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.dataField]: e.value
        }));
    };

    useEffect(() => {
        if (isOpen) {
            setSase(document.getElementById("Entity_Sase").value);
            setFormData(prev => ({
                ...prev,
                chassis_no: document.getElementById("Entity_Sase").value
            }));
        }
    }, [isOpen]);

    return (
        <>
            <style>
                {`
                    .dx-layout-manager .dx-field-item {
                        padding-bottom: 15px;
                    }
                    .dx-layout-manager .dx-field-item:last-child {
                        padding-bottom: 0;
                    }
                    .camera-upload-wrapper {
                        border: 2px dashed #ccc;
                        padding: 15px;
                        border-radius: 4px;
                        margin-top: 15px;
                    }
                    .camera-upload-wrapper label {
                        display: block;
                        margin-bottom: 10px;
                        font-weight: 500;
                    }
                    @media (max-width: 768px) {
                        .dx-field-item-label {
                            padding-bottom: 5px;
                        }
                    }
                `}
            </style>
            <Draggable handle=".modal-header">
                <audio id="errorSound" src={erorSound} preload="auto"></audio>
                <Modal size='lg' isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} >
                    <ModalHeader style={{ cursor: "pointer" }} className='modal-header' toggle={() => setIsOpen(!isOpen)}>
                        {area} - {t("Hasar Bildirimi")}
                    </ModalHeader>
                    <ModalBody>
                        <Form
                            ref={formRef}
                            formData={formData}
                            items={formItems.items}
                            onFieldDataChanged={handleFieldDataChanged}
                            showValidationSummary={true}
                            validationGroup="damageForm"
                        />

                        <div className="camera-upload-wrapper">
                            <label>{t("Hasar Görseli")}</label>
                            <FileUploader
                                selectButtonText={t("Fotoğraf Çek")}
                                labelText={t("veya dosya seç")}
                                accept="image/*"
                                uploadMode="useForm"
                                onValueChanged={(e) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        image: e.value[0]
                                    }));
                                }}
                                multiple={false}
                                inputAttr={{
                                    capture: "environment"  // Arka kamerayı kullan
                                }}
                            />
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button
                                text={t("İptal")}
                                onClick={() => setIsOpen(false)}
                                stylingMode="outlined"
                            />
                            &emsp;
                            <Button
                                text={t("Kaydet")}
                                type="default"
                                onClick={createDamegeReport}
                                stylingMode="contained"
                                useSubmitBehavior={true}
                                validationGroup="damageForm"
                            />
                        </div>
                    </ModalBody>
                </Modal>
            </Draggable>
        </>
    )
}

export default HasarBildirimiAddModal